<template>
   <div class="flex flex-col items-start w-full">

     <div class="flex items-end justify-start w-full">
      <div class="w-1/2 pt-2 pr-2">
        <label class="block pr-4 text-lg font-medium" for="editId">Item to edit</label>
        <select
          v-model="editId"
          @change="loadEditItem"
          class="w-full p-2 border rounded"
          id="editId"
        >
          <option :value="listItem.id" v-for="(listItem, index) in items" :key="index + '-live-item'">
            {{ listItem.name }}
          </option>
        </select>
      </div>

     </div>

      <hr v-if="showEditItem && !loading" class="w-full my-5 ">

      <!-- Displays the item -->
      <item-display
        v-if="showEditItem && !loading"
        :item.sync="item"
        :disabled="loading"
      />

      <div class="my-10" v-if="loading">
        Loading...
      </div>

      <general-button
        v-if="showEditItem"
        @button-click="$emit('edit-item')"
        :disabled="loading"
        text="Update Item"
        color="green"
      />

    </div>

</template>

<script>
import GeneralButton from './GeneralButton.vue';
import ItemDisplay from './ItemDisplay.vue';

export default {
  name: 'edit-section',
  props: {
    items: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    showEditItem: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    GeneralButton,
    ItemDisplay,
  },
  data() {
    return {
      editId: '',
    };
  },
  methods: {
    loadEditItem() {
      this.$emit('load-edit-item', this.editId);
      this.editId = '';
      this.$emit('update:showEditItem', true);
    },
  },
};
</script>
